<template>
  <div class="caifu_ts">
    <topNav typeName vuePage="#cfdj" title="提升我的活跃等级" back="1" hydjsm="1"></topNav>
    <div class="ts_center">
      <p class="ts_center_title">活跃值累计规则</p>
      <div class="ts_center_info">
        <span>加分项</span>
        <span>分值</span>
      </div>
      <ul>
        <li v-for="n in livelyRolueList" :key="n.id">
          <p>{{n.title}}</p>
          <p>{{n.cont}}</p>
        </li>
      </ul>
    </div>

    <div class="ts_center ts_center_b">
      <p class="ts_center_title">消费值加分规则</p>
      <div class="ts_center_info">
        <span>加分项</span>
        <span>分值</span>
      </div>
      <ul>
        <li>
          <p>礼物消费</p>
          <p>+礼物经验值</p>
        </li>
        <li>
          <p>道具商城钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
        <li>
          <p>守护钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
        <li>
          <p>弹幕钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
        <li>
          <p>私信钻石消费</p>
          <p>+{{multiple}}*消费钻石数量</p>
        </li>
      </ul>
    </div>
  </div>
</template>





<script>
import topNav from "../index/top_nav";

export default {
  components:{topNav},
  data() {
    return {
      multiple: "", //消费砖石的倍数
      //活跃值累计规则
      livelyRolueList: [
        // { id: 1, scorename: "每日登录", scoreInfo: "+200 (每日上限200)" },
        // { id: 2, scorename: "每日累计在线10分钟", scoreInfo: "+400 (每日上限800)" },
        // { id: 3, scorename: "每日点赞动态1次", scoreInfo: "+100 (每日上限1000)" },
        // { id: 4, scorename: "每日评论动态1次", scoreInfo: "+200 (每日上限2000)" },
        // { id: 5, scorename: "完成日常任务1条", scoreInfo: "+1000 (每日上限3000)" },
      ]
    };
  },
  methods: {
    getmultiple() {
      let _this = this;
      let data = {
        type: 1
      };
      _this.$jsonp(_this.$apis("grade_wealth"), data, res => {
        _this.multiple = res.body.data.data.list.multiple;
      });

      _this.$jsonp(_this.$apis("grade_lively_rolue"), {}, res => {
        _this.livelyRolueList = res.body.data.data.list.taskdown;
      });
    }
  },
  mounted() {
    this.$tool.setTitle("提升我的活跃等级");
    this.getmultiple();
  }
};
</script>









<style lang="scss" scoped>
.caifu_ts {
  width: 100%;
}
.ts_center {
  background-color: #fff;
  padding: 0 15px;
  margin-bottom: 10px;
  .ts_center_title {
    padding: 30px 0;
    color: #414141;
    font-weight: 600;
  }
  .ts_center_info {
    color: #414141;
    font-weight: 600;
    font-size: 0.8rem;
    margin-bottom: 10px;
  }
  .ts_center_info span {
    display: inline-block;
    width: 50%;
  }
  ul li {
    color: #b0b0b0;
    display: flex;
    font-size: 0.9rem;
    padding: 18px 0;
  }
  li p {
    width: 50%;
  }
}
.ts_center_b {
  margin-bottom: 100px;
}
</style>